// const devUrl = "http://localhost:8066/";
const devUrl = "https://ylg.jd-sf.com";//正式
export default {
  tokenKey: 'Authorization',//存在sessionStorage里面的tokenKeyhttp://at.alicdn.com/t/font_1047431_pbh36d6nwfl.css
  apiUrl: devUrl,
  apiPrefix: "api",
  vant: true,
  siteName: '',
  productionGzip: true,
  vueTagData: {},
  productionGzipExtensions: ['js', 'css'],
}




// WEBPACK FOOTER //
// ./src/config/vueConfig.js